module.exports = __webpack_public_path__ + "static/media/Webscapes_poster.b9533fc5.png";